import React, { useState } from 'react';
// 💡 IMPORTANT: Assumes isAttestationComplete is now exported from InLine_validations.js
import { isValidEmail, isValidDOB, isAttestationComplete } from '../utilities/InLine_validations'; 
import DeclarationsInteractive from '../members/DeclarationsInteractive';
import MembersArea from '../members/MembersArea';

const Manage_membership = ({ setView }) => {
  const [mode, setMode] = useState('login');

  // ✅ For Declarations Test Integration
  const [showDeclarations, setShowDeclarations] = useState(false);
  const [testUserName, setTestUserName] = useState('');
  const [testKeyId, setTestKeyId] = useState('');
  const [showMembersArea, setShowMembersArea] = useState(false);

  // ✅ GUID generator for Key ID
  const makeGuid = () =>
    window.crypto?.randomUUID?.() ||
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });

  // ✅ Form states (your original)
  const [regData, setRegData] = useState({
    name: '',
    email: '',
    dob: '',
    password: '',
    acceptAutoPassword: false,
  });

  const [loginData, setLoginData] = useState({
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e, formType = 'reg') => {
    const { name, value, type, checked } = e.target;
    const setter = formType === 'reg' ? setRegData : setLoginData;
    setter(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const BackButton = () => (
    <button type="button" onClick={() => setView('home')} className="btn btn-secondary mb-3">
      ← Back to Home
    </button>
  );

  // ✅ UPDATED login logic to check for attestation completion
  const handleLoginSubmit = (e) => {
    e.preventDefault();

    // 1. Check if attestation is already 10/10 complete
    if (isAttestationComplete()) {
      // Skip declarations and go straight to MembersArea
      setShowMembersArea(true);
      setShowDeclarations(false);
    } else {
      // Attestation not complete, initiate declarations process
      const guid = makeGuid();       
      setTestUserName("Test_NWP");   
      setTestKeyId(guid);
      setShowDeclarations(true);     // show Declaration phase
      setShowMembersArea(false);     // Ensure MembersArea is hidden until declarations complete
    }
  };

  // ✅ Validation unchanged
  const validateRegistrationForm = () => {
    let currentErrors = {};
    let isValid = true;

    if (!regData.name.trim()) {
      currentErrors.name = 'Full Name is required.'; isValid = false;
    }
    if (!regData.email || !isValidEmail(regData.email)) {
      currentErrors.email = 'A valid email is required.'; isValid = false;
    }
    if (!regData.dob) {
      currentErrors.dob = 'Date of Birth is required.'; isValid = false;
    } else if (!isValidDOB(regData.dob)) {
      currentErrors.dob = 'Must be between 18 and 100 years old.'; isValid = false;
    }
    if (!regData.acceptAutoPassword && !regData.password) {
      currentErrors.password = 'Set a password or accept auto-generated password.'; isValid = false;
    }

    setErrors(currentErrors);
    return isValid;
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    if (validateRegistrationForm()) {
      alert('Registration validated.');
    }
  };

  // ✅ Layout helper
  const FieldRow = ({ id, label, children }) => (
    <div className="row g-2 align-items-center mb-3">
      <label htmlFor={id} className="col-6 col-form-label">{label}</label>
      <div className="col-6">{children}</div>
    </div>
  );

  const InputColumnRow = ({ children }) => (
    <div className="row g-2 mb-3">
      <div className="col-6"></div>
      <div className="col-6">{children}</div>
    </div>
  );

  // ✅ LOGIN FORM
  const LoginForm = () => (
    <form onSubmit={handleLoginSubmit}>
      <h2 className="h4 mb-2">User Login</h2>

      <FieldRow id="login-email" label="Email:">
        <input
          type="email"
          id="login-email"
          name="email"
          className="form-control"
          value={loginData.email}
          onChange={(e) => handleChange(e, 'login')}
          required
        />
      </FieldRow>

      <FieldRow id="login-password" label="Password:">
        <input
          type="password"
          id="login-password"
          name="password"
          className="form-control"
          value={loginData.password}
          onChange={(e) => handleChange(e, 'login')}
          required
        />
      </FieldRow>

      <InputColumnRow>
        <button type="submit" className="btn btn-primary">Log In (Test with Attestations)</button>
      </InputColumnRow>
    </form>
  );

  // ✅ REGISTER FORM (unchanged from your working version)
  const RegisterForm = () => (
    <form onSubmit={handleRegisterSubmit}>
      <h2 className="h4 mb-2">New User Registration</h2>
      {/* ... unchanged registration code ... */}
      <InputColumnRow>
        <button type="submit" className="btn btn-primary">Register</button>
      </InputColumnRow>
    </form>
  );

  let CurrentForm = mode === 'register' ? RegisterForm : LoginForm;

  return (
    <div className="container-fluid py-3">
      <BackButton />

      {/* ✅ CORRECTED CASCADING RENDERING LOGIC (Fixes duplication) */}
      {showDeclarations ? (
        <DeclarationsInteractive
          userName={testUserName}
          issuedKeyId={testKeyId}
          onComplete={(doc) => {
            console.log("Declarations Completed:", doc);
            setShowDeclarations(false);
            // Transition to MembersArea after successful completion
            setShowMembersArea(true); 
          }}
        />
      ) : showMembersArea ? (
        <MembersArea /> // Dashboard/Payment Stage View
      ) : (
        <CurrentForm /> // Login/Register View
      )}
    </div>
  );
};

export default Manage_membership;